export default "__VITE_ASSET__86fgeVqp__"